import {call, put, select, takeLatest} from 'redux-saga/effects';
import {
    DELETED_COMPANIES_REQUEST,
    DELETED_COMPANIES_SUCCESS,
    DELETED_COMPANIES_FAIL,

    SINGLE_COMPANIES_REQUEST,
    SINGLE_COMPANIES_SUCCESS,
    SINGLE_COMPANIES_FAIL, UPDATE_COMPANIES_SUCCESS, UPDATE_COMPANIES_FAIL, UPDATE_COMPANIES_REQUEST,
} from '../actions/companies.js';
import Api from '../../Api.js';
import {toast} from "react-toastify";
import {word} from "../../word.js";
import _ from "lodash";

const errorNotify = () => toast.error(word.error_process, {position: "top-center", theme: "colored",});
const successNotify = () => toast.success(word.success_process,  { position: "top-center",theme: "colored", });

function* handleDeletedCompaniesRequest(action) {

    try {
        const alreadyFetched = yield select((state) => state.companies.company);
        if (!_.isEmpty(alreadyFetched) && !action.payload.fetch) return;
        const {data} = yield call(Api.deletedCompanies);
        yield put({
            type: DELETED_COMPANIES_SUCCESS,
            payload: {data},
        });
    } catch (e) {
        errorNotify()
        yield put({
            type: DELETED_COMPANIES_FAIL,
            payload: {error: e.response},
        });
    }
}

function* handleSingleCompaniesRequest(action) {

    try {
        const {id} = action.payload
        const {data} = yield call(Api.companySingle,id);
        yield put({
            type: SINGLE_COMPANIES_SUCCESS,
            payload: {data},
        });
    } catch (e) {
        errorNotify()
        yield put({
            type: SINGLE_COMPANIES_FAIL,
            payload: {error: e.response},
        });
    }
}

function* handleUpdateCompaniesRequest(action) {

    try {
        const {id, form} = action.payload
        yield call(Api.updateCompanies,id,form);
        const {data} = yield call(Api.companySingle,id);
        successNotify()
        yield put({
            type: UPDATE_COMPANIES_SUCCESS,
            payload: {data},
        });
    } catch (e) {
        errorNotify()
        yield put({
            type: UPDATE_COMPANIES_FAIL,
            payload: {error: e.response},
        });
    }
}


export default function* watcher() {
    yield takeLatest(DELETED_COMPANIES_REQUEST, handleDeletedCompaniesRequest);
    yield takeLatest(SINGLE_COMPANIES_REQUEST, handleSingleCompaniesRequest);
    yield takeLatest(UPDATE_COMPANIES_REQUEST, handleUpdateCompaniesRequest);

}
